import { css, Theme } from '@emotion/react';

const rem = (value: number) => `${value / 16}rem`;

const xs = css`
  font-size: ${rem(12)};
  line-height: 1.5;
`;

const s = css`
  font-size: ${rem(14)};
  line-height: 1.5;
`;

const base = (theme: Theme) => css`
  font-size: ${rem(14)};
  line-height: 1.5;

  ${theme.breakpoints.up('lg')} {
    font-size: ${rem(16)};
  }
`;

const l = (theme: Theme) => css`
  font-size: ${rem(16)};
  line-height: 1.5;

  ${theme.breakpoints.up('sm')} {
    font-size: ${rem(18)};
  }

  ${theme.breakpoints.up('lg')} {
    font-size: ${rem(20)};
  }
`;

const xl = (theme: Theme) => css`
  font-size: ${rem(26)};
  line-height: 1.2;

  ${theme.breakpoints.up('sm')} {
    font-size: ${rem(30)};
  }

  ${theme.breakpoints.up('md')} {
    font-size: ${rem(34)};
  }

  ${theme.breakpoints.up('lg')} {
    font-size: ${rem(40)};
  }
`;

const xxl = (theme: Theme) => css`
  font-size: ${rem(28)};
  line-height: 1.2;

  ${theme.breakpoints.up('sm')} {
    font-size: ${rem(34)};
  }

  ${theme.breakpoints.up('md')} {
    font-size: ${rem(40)};
  }

  ${theme.breakpoints.up('lg')} {
    font-size: ${rem(50)};
  }
`;

export const fontSize = {
  xs,
  s,
  base,
  l,
  xl,
  xxl,
};
